<template>
  <div class="d-flex" style="height: 100%">
    <div class="dashboard-map-content">
      <div class="dashboard-loading-mask" v-if="isLoading">
        <div class="dashboard-loading-message">ページを読み込んでいます...</div>
        <VueLoading type="spin" color="#eee" :size="loadingSize" />
      </div>
      <base-map style="position: absolute" />
    </div>
    <div v-if="isShowMapDetail" style="border-left: 1px solid #c1c1c1">
      <v-toolbar dense flat color="primary" height="36">
        <v-card class="body-2 white--text" color="primary" flat width="320">
          {{ mapDetail.title }}
        </v-card>
        <v-spacer />
        <v-btn class="mr-1" dark icon small @click="closeMapDetail">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card
        tile
        flat
        height="calc(100vh - 40px)"
        width="400"
        style="overflow-y: auto;"
      >
        <template v-if="mapDetail.contents === 'stage-detail'">
          <StageDetail />
        </template>
        <template v-if="mapDetail.contents === 'rainfall-detail'">
          <RainDetail />
        </template>
        <template v-if="mapDetail.contents === 'dam-detail'">
          <DamDetail />
        </template>
        <template v-if="mapDetail.contents === 'camera-detail'">
          <CameraDetail />
        </template>
        <template v-if="mapDetail.contents === 'live-camera-detail'">
          <LiveCameraDetail />
        </template>
        <template v-if="mapDetail.contents === 'wind-detail'">
          <WindDetail />
        </template>
      </v-card>
    </div>
    <monitoring v-if="isMonitoring" />
    <CameraMonitor v-if="isCameraMonitor && !isShowMapDetail" />
  </div>
</template>

<script>
import { Risk } from "../enums/Risk";
import BaseMap from "../components/base-map/BaseMap";
import Monitoring from "../components/Monitoring";
import StageDetail from "../components/base-map/details/StageDetail";
import RainDetail from "../components/base-map/details/RainDetail";
import DamDetail from "../components/base-map/details/DamDetail";
import CameraDetail from "../components/base-map/details/CameraDetail";
import LiveCameraDetail from "../components/base-map/details/LiveCameraDetail";
import WindDetail from "../components/base-map/details/WindDetail";
import CameraMonitor from "../components/CameraMonitor";
import { VueLoading } from "vue-loading-template";

export default {
  name: "Dashboard",
  components: {
    VueLoading,
    Monitoring,
    BaseMap,
    StageDetail,
    RainDetail,
    DamDetail,
    CameraDetail,
    LiveCameraDetail,
    WindDetail,
    CameraMonitor
  },
  data() {
    return {
      Risk,
      loadingSize: { width: "80px", height: "80px" }
    };
  },
  watch: {
    selectedRisk() {
      this.closeMapDetail();
    },
    baseDate() {
      if (this.isShowMapDetail !== true) {
        return;
      }
      const info = this.$store.getters.selectedObservatory;
      this.$store.dispatch("FETCH_SELECTED_OBSERVATORY_DATA", info);
    }
  },
  computed: {
    selectedRisk() {
      return this.$store.getters.selectedRisk;
    },
    isShowMapDetail() {
      return this.$store.getters.isShowMapDetail;
    },
    mapDetail() {
      return this.$store.getters.mapDetail;
    },
    isMonitoring() {
      return this.$store.getters.isMonitoring;
    },
    isCameraMonitor() {
      return this.$store.getters.isCameraMonitor;
    },
    baseDate() {
      return this.$store.getters.baseDate;
    },
    isLoading() {
      return this.$store.getters.isLoading;
    }
  },
  methods: {
    closeMapDetail() {
      const dialog = {
        isShowing: false
      };
      this.$store.commit("SET_MAP_DETAIL", dialog);
    }
  }
};
</script>

<style lang="scss">
.dashboard-map-content {
  width: 100%;
  position: relative;
  .dashboard-loading-mask {
    position: absolute;
    z-index: 3000;
    width: 100%;
    height: 100%;
    padding-top: 30vh;
    background-color: rgba(0, 0, 0, 0.5);
    text-align: center;
  }
  .dashboard-loading-message {
    font-size: 0.9em;
    color: white;
  }
}
</style>
